export default __webpack_public_path__ + "static/and-case-2-b33743bf88332978f30380f700de1df0.webp";